module.exports = __webpack_public_path__ + "static/img/1Business-Intelligence.f11106f4.gif";